import React from "react";
var __jsx = React.createElement;
import useDirection from "@hooks/useDirection";
import { useLang } from "@/common/Contexts/LanguageContext";
import { labels } from "@componentsShared/DateCalendarGregorian/data";
export var DateCalendarJSX = function DateCalendarJSX(_ref) {
  var day = _ref.day,
    month = _ref.month,
    year = _ref.year,
    error = _ref.error,
    calendarType = _ref.calendarType,
    years = _ref.years,
    validMonths = _ref.validMonths,
    validDays = _ref.validDays,
    months = _ref.months,
    label = _ref.label,
    handleYearChange = _ref.handleYearChange,
    handleMonthChange = _ref.handleMonthChange,
    handleDayChange = _ref.handleDayChange,
    handleCalendarTypeChange = _ref.handleCalendarTypeChange;
  // Set direction based on language
  var dir = useDirection();
  var lang = useLang();
  var border = error ? 'border-red-500 ring-red-500' : 'border-gray-300';
  var textColor = error ? 'text-red-700' : 'text-[#484848]';
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full",
    dir: dir
  }, label && /*#__PURE__*/React.createElement("label", {
    className: "block mb-3 text-xs font-bold leading-6 text-gray-700"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "mb-4 flex items-center"
  }, /*#__PURE__*/React.createElement("label", {
    className: "inline-flex items-center"
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    className: "form-radio h-5 w-5 text-blue-600",
    checked: calendarType === 'G',
    onChange: function onChange() {
      return handleCalendarTypeChange('G');
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "ml-2 ".concat(textColor)
  }, labels.gregorian[lang])), /*#__PURE__*/React.createElement("label", {
    className: "inline-flex items-center"
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    className: "form-radio h-5 w-5 text-blue-600",
    checked: calendarType === 'H',
    onChange: function onChange() {
      return handleCalendarTypeChange('H');
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "ml-2 ".concat(textColor)
  }, labels.hijri[lang]))), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-3 gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React.createElement("label", {
    className: "".concat(textColor, " mb-1  block mb-3 text-xs font-bold leading-6")
  }, labels.year[lang]), /*#__PURE__*/React.createElement("select", {
    className: "block w-full rounded-md border ".concat(border, " shadow-sm focus:border-blue-500 focus:ring-blue-500 p-2 disabled:border-none appearance-none outline-none bg-transparent"),
    value: year || '',
    onChange: handleYearChange,
    disabled: !calendarType
  }, /*#__PURE__*/React.createElement("option", {
    value: "",
    disabled: true,
    style: error ? {
      color: '#dc2626'
    } : {}
  }, labels.selectYear[lang]), years.map(function (y) {
    return /*#__PURE__*/React.createElement("option", {
      key: "year-".concat(y),
      value: y
    }, y);
  }))), /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React.createElement("label", {
    className: "".concat(textColor, " mb-1  block mb-3 text-xs font-bold leading-6")
  }, labels.month[lang]), /*#__PURE__*/React.createElement("select", {
    className: "block w-full rounded-md border ".concat(border, " shadow-sm focus:border-blue-500 focus:ring-blue-500 p-2 disabled:pointer-events-none disabled:!bg-gray-500 disabled:opacity-30 disabled:text-white disabled:border-none appearance-none outline-none bg-transparent"),
    value: month !== null ? month : '',
    onChange: handleMonthChange,
    disabled: !calendarType || year === null || validMonths.length === 0
  }, /*#__PURE__*/React.createElement("option", {
    value: "",
    disabled: true,
    style: error ? {
      color: '#dc2626'
    } : {}
  }, labels.selectMonth[lang]), validMonths.map(function (monthIndex) {
    return /*#__PURE__*/React.createElement("option", {
      key: "month-".concat(monthIndex),
      value: monthIndex
    }, months[monthIndex]);
  }))), /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React.createElement("label", {
    className: "".concat(textColor, " mb-1  block mb-3 text-xs font-bold leading-6")
  }, labels.day[lang]), /*#__PURE__*/React.createElement("select", {
    className: "block w-full rounded-md border ".concat(border, " shadow-sm focus:border-blue-500 focus:ring-blue-500 p-2 disabled:pointer-events-none disabled:!bg-gray-500 disabled:opacity-30 disabled:text-white disabled:border-none appearance-none outline-none bg-transparent"),
    value: day || '',
    onChange: handleDayChange,
    disabled: !calendarType || year === null || month === null || validDays.length === 0
  }, /*#__PURE__*/React.createElement("option", {
    value: "",
    disabled: true,
    style: error ? {
      color: '#dc2626'
    } : {}
  }, labels.selectDay[lang]), validDays.map(function (d) {
    return /*#__PURE__*/React.createElement("option", {
      key: "day-".concat(d),
      value: d
    }, d);
  })))), error && /*#__PURE__*/React.createElement("div", {
    className: "mt-2 text-red-600 text-sm"
  }, error));
};